<template>
  <card>
    <h3 slot="header" class="mb-0">Edit Task Template for ({{ model.task_template_name }}) </h3>
    <div class="text-right">
    </div>
    <form class="needs-validation"
          @submit.prevent="submit">

      <div class="form-row">
        <b-col md="12">
          <base-input label="Template Name"
                      name="Template Name"
                      placeholder="Template Name"
                      v-model="model.task_template_name">
          </base-input>
        </b-col>

        <b-col md="11">
          <base-input label="Set Milestone Template (Note: Once your create your 1st Task your switch/change this anymore)."
                      name="Milestone Template"
                      v-model="model.milestone_template_id" v-if="task_detail_count == 0">
            <select class="form-control" v-model="model.milestone_template_id">
              <option Selected disabled value="x">-- Please Select A Milestone Template --</option>
              <option v-for="item in milestone_template" :key="item.milestone_template_id" v-bind:value="item.milestone_template_id">{{ item.milestone_template_name }}</option>
            </select>
          </base-input>
          <base-input label="Set Milestone Template (Note: Once your create your 1st Task your switch/change this anymore)."
                      name="Milestone Template"
                      v-model="model.milestone_template_id" v-else>
            <select class="form-control" v-model="model.milestone_template_id" disabled>
              <option Selected disabled value="x">-- Please Select A Milestone Template --</option>
              <option v-for="item in milestone_template" :key="item.milestone_template_id" v-bind:value="item.milestone_template_id">{{ item.milestone_template_name }}</option>
            </select>
          </base-input>
        </b-col>

        <b-col md="1">
          <br>
          <base-button size="sm" type="primary" @click="checkMilestoneDetail()">Milestone Details</base-button>
        </b-col>
      </div>
      <base-button type="primary" @click="updateData()" >Update / Save</base-button>
      <base-button type="primary" @click="$router.back()">Cancel</base-button>
      <div>
        <br>
        <h5 class="text-danger"> Note : <br>
          <i>
          1. To Create New / Update Milestone please proceed to Menu >> Template >> Milestone Template OR "Click" on "Milestone Details"
          <br>
          2. Your cannot swtich / change the Milestone Template anymore once you created your 1st Task Template Detail. But you can still Create/Update the Milestone Template.
          <br>
          3. All Milestone Template Details will follow according to SELECTED Milestone Template.
          <br>
          4. SET Milestone Template DROPBOX will be disabled once a Task Template Detail is Created, To check the detail Please Press BACK.
          </i>
        </h5>
      </div>
    </form>
  </card>
</template>
<script>
  import BaseSlider from '@/components/BaseSlider'
  import {LoginURL, clientId, clientSecret, apiDomain, getHeader} from '@/assets/js/config.js'
  import axios from 'axios'
  import ErrorFunctionMixin from '@/assets/js/errorFunctionMix.js'

  export default {
    mixins: [ErrorFunctionMixin],
    components: {
      BaseSlider
    },
    created()
    {
      this.model.task_template_id = this.$route.params.id

      axios.get(apiDomain + 'template/task_template/'+this.model.task_template_id, { headers: getHeader() })
      .then ( response => {
        if (response.status === 200)
        {
          this.model.task_template_id = response.data.data[0].task_template_id
          this.model.task_template_name = response.data.data[0].task_template_name
          this.model.milestone_template_id = response.data.data[0].milestone_template.milestone_template_id
        }
      })
      .catch ( error => {
        console.log(error.response.status)
        this.errorFunction(error, "Task Template Information")
      } );

      axios.get(apiDomain + 'template/milestone_template', { headers: getHeader() })
      .then ( response => {
        if (response.status === 200)
        {
          this.milestone_template = response.data.data
        }
      })
      .catch ( error => {
        console.log(error.response.status)
        this.errorFunction(error, "Milestone Template Information")
      } );

      axios.get(apiDomain + 'template/task_template.detail_count/'+this.model.task_template_id, { headers: getHeader() })
      .then ( response => {
        if (response.status === 200)
        {
          this.task_detail_count = response.data
        }
      })
      .catch ( error => {
        console.log(error.response.status)
        this.errorFunction(error, "Task Template Details Information")
      } );
    },
    data() {
      return {
        model: {
          task_template_name: null,
          task_template_id: null,
          milestone_template_id: null,
        },
        milestone_template: [],
        task_detail_count: 1,
      }
    },
    methods: {
      checkMilestoneDetail()
      {
        if (this.model.milestone_template_id == 'x')
        {
          this.$notify({
            message:
              '<b>Invalid Input : Milestone Template </b> - Please select a Milestone Template before dive into the Details',
            timeout: 10000,
            icon: 'ni ni-bulb-61',
            type: 'danger',
          });
        }
        else
        {
          this.$router.push({path: '/templates/milestoneTemplateDetailListing/' + this.model.milestone_template_id })
        }
      },
      updateData()
      {
        if ( !this.model.task_template_name || this.model.milestone_template_id == 'x')
        {
          this.$notify({
            message:
              '<b>Invalid Input : All Column are Mandatory in Task Template</b> - These field are required.',
            timeout: 10000,
            icon: 'ni ni-bulb-61',
            type: 'danger',
          });
        }
        else
        {
          axios.put(apiDomain + 'template/task_template/' + this.model.task_template_id, this.model, { headers: getHeader() })
          .then ( response => {
          if (response.status === 200)
          {
              this.$notify({
              message:
                '<b>Edit Milestone Template : ' + this.model.task_template_name + '</b> - Successfully Updated.',
              timeout: 10000,
              icon: 'ni ni-bell-55',
              type: 'default',
              });
              this.$router.back()
            }
          })
          .catch ( error => {
              console.log(error.response.data.errors)
              this.errorFunction(error, "Edit Task Template Information")
          } );
        }
      },
    }
  }
</script>
<style>
</style>
